import React from 'react';
import { Box, Drawer, Paper, useMediaQuery, useTheme } from '@mui/material';
import ClientDetailsPanel from './ClientDetailsPanel';

export const CLIENT_DETAILS_DRAWER_WIDTH = {
  md: 640,
  lg: 760,
  mobileMax: 560,
};

const ClientDetailsDrawer = ({ clientId, open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (!open || !clientId) {
    return null;
  }

  const panel = (
    <ClientDetailsPanel clientId={clientId} onClose={onClose} variant="drawer" />
  );

  if (isMobile) {
    return (
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: { width: '100%', maxWidth: CLIENT_DETAILS_DRAWER_WIDTH.mobileMax },
        }}
      >
        <Box sx={{ overflow: 'auto', height: '100%' }}>{panel}</Box>
      </Drawer>
    );
  }

  return (
    <Paper
      elevation={0}
      sx={{
        width: { md: CLIENT_DETAILS_DRAWER_WIDTH.md, lg: CLIENT_DETAILS_DRAWER_WIDTH.lg },
        flexShrink: 0,
        borderLeft: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'stretch',
        maxHeight: 'calc(100vh - 160px)',
        position: 'sticky',
        top: 16,
        borderRadius: '0 12px 12px 0',
        overflow: 'hidden',
      }}
    >
      <Box sx={{ overflow: 'auto', flex: 1 }}>{panel}</Box>
    </Paper>
  );
};

export default ClientDetailsDrawer;
